var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page f-c"},[_c('div',{staticClass:"f-c-c"},[_c('h1',[_vm._v("页面走丢了")]),_c('h2',[_vm._v("404")])])])
}]

export { render, staticRenderFns }